import SideMenuContainer from './SideMenuContainer';

export default SideMenuContainer;
